<div
  (click)="selectJob(job)"
  class="widget-container flex w-full flex-wrap"
  style="flex-direction: row"
  [class.highlighted]="selectedJob?.id == job?.id"
  *ngIf="job != null"
>
  <div class="map-box">
    <div class="map-badges z-5">
      <span
        *ngIf="job.isFromRouteRecommendation"
        class="bg-purple-400 border-round-right-2xl px-2 py-1 text-white"
        ><i class="fa fa-star-o"></i> Planned Route</span
      >
      <span
        *ngIf="showWatcherIndicator"
        class="watcher-indicator bg-orange-500 border-round-2xl px-2 py-1 text-white"
      >
        <i class="fa fa-eye"></i> {{ job.supplierWatchCount }}
        {{ job.supplierWatchCount == 1 ? 'person is' : 'people are' }} watching this job
      </span>
    </div>
    <supplier-jobs-inbox-item-map
      [(selectedTaskId)]="chosenTaskId"
      [(taskMode)]="taskMode"
      [jobId]="job.id"
      [tasks]="job.tasks"
    >
    </supplier-jobs-inbox-item-map>
  </div>

  <div (dblclick)="viewJobDetail($event)" class="task-info-box">
    <div style="width: 100%">
      <div class="widget-body style2023">
        <div>
          <div class="flex task-select-tabs">
            <div
              *ngFor="let task of job.tasks; let i = index"
              class="task-tab-item"
              [class.tab-highlighted]="highlightedTaskId == task.id"
              [class.tab-cancelled]="task.isCancelled && job.isFromRouteRecommendation"
              (click)="setHighlighted($event, task.id)"
            >
              {{ task.vehicle.registrationNumber }}
              <i
                *ngIf="task.isCancelled && job.isFromRouteRecommendation"
                pTooltip="Task is Cancelled"
                class="fa fa-ban ml-1"
              ></i>
            </div>
          </div>
        </div>

        <div class="pl-3 pr-2" style="min-height: 278px">
          <div *ngFor="let task of job.tasks; let i = index">
            <div
              class="task-container"
              *ngIf="highlightedTaskId == task.id"
              (click)="toggleMap($event, task.id)"
              [class.unrotate]="showMapForTaskId != task.id"
              [class.rotate]="showMapForTaskId == task.id"
            >
              <div class="task-wrapper">
                <task-vehicle-details [task]="task"></task-vehicle-details>
                <vertical-dots-container [position]="'start'" [narrowDots]="true">
                  <task-time-and-location-container
                    [styleType]="2"
                    [isFirstItem]="true"
                    [isLastItem]="false"
                    [isPickup]="true"
                    [task]="task"
                    [taskNumber]="i + 1"
                    [location]="task.pickupLocation"
                    [showTaskBadges]="true"
                    [earliestDateTime]="task.pickupEarliestDateTime"
                    [latestDateTime]="task.pickupLatestDateTime"
                    [scheduledDateTime]="task.taskSupplierSchedule?.specifiedPickUpTime"
                    [isRoute]="job.isFromRouteRecommendation"
                  ></task-time-and-location-container>
                </vertical-dots-container>

                <vertical-dots-container
                  position="middle"
                  iconClass="fa fa-circle"
                  iconSize="tiny"
                  [narrowDots]="true"
                >
                  <task-divider
                    [showTime]="task.estimateTime"
                    [showMiles]="task.distance / 1609"
                  ></task-divider>
                </vertical-dots-container>

                <vertical-dots-container
                  [narrowDots]="true"
                  [iconClass]="i == job.tasks.length - 1 ? 'fa fa-circle' : 'fa fa-circle-o'"
                  [position]="'end'"
                >
                  <task-time-and-location-container
                    [styleType]="2"
                    [isFirstItem]="true"
                    [isLastItem]="true"
                    [isPickup]="false"
                    [taskNumber]="i + 1"
                    [location]="task.dropoffLocation"
                    [task]="task"
                    [earliestDateTime]="task.dropoffEarliestDateTime"
                    [latestDateTime]="task.dropoffLatestDateTime"
                    [scheduledDateTime]="task.taskSupplierSchedule?.specifiedDropOffTime"
                    [isRoute]="job.isFromRouteRecommendation"
                  ></task-time-and-location-container>
                </vertical-dots-container>
              </div>

              <div
                *ngFor="let x of task.checklistSubCategories"
                style="margin-right: 7px; display: inline-block; padding-bottom: 10px"
              >
                <checklist-category-item
                  [subCategory]="x.checklistSubCategory"
                ></checklist-category-item>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="pricing-box">
    <div class="show-route-itinerary-button" *ngIf="job.isFromRouteRecommendation">
      <p-button (click)="openRouteItineraryPopup()" icon="fa fa-list"></p-button>
    </div>
    <div class="w-full">
      <div class="pricing-box-inner">
        <div class="flex-grow-1 job-total-wrapper">
          <div class="job-number-wrapper">
            <span class="job-number">{{ job?.jobNumber }}</span>
          </div>
          <div
            [class.price-details-enabled]="showPriceDetailsEnabled"
            class="job-total-wrapper"
            (click)="onShowPriceDetails($event)"
          >
            <ng-container *ngIf="job?.priceIncreasePercentage > 0; else noIncrease">
              <span class="job-total">
                <span class="price-increased">
                  <svg class="price-increase-arrow" viewBox="0 0 24 24">
                    <path d="M2 17l7-7 4 4 9-9M15 5h7v7" /></svg
                  >&pound;{{ job?.supplierPrice | number : '1.2-2' }}
                </span>
              </span>
              <div class="price-increase-pill-row">
                <span class="price-increase-pill"
                  >Increased by {{ job.priceIncreasePercentage }}%</span
                >
              </div>
            </ng-container>
            <ng-template #noIncrease>
              <span class="job-total">&pound;{{ job?.supplierPrice | number : '1.2-2' }}</span>
            </ng-template>
          </div>
          <div
            *ngIf="supplierPremiumTotal > 0"
            class="supplier-premium"
            [class.after-price-increase]="job?.priceIncreasePercentage > 0"
            (click)="showSupplierPremiums = !showSupplierPremiums"
          >
            incl. {{ supplierPremiumTotal | currency : 'GBP' : 'symbol' : '1.2-2' }} supplier
            premium
            <i class="fa fa-info-circle"></i>
            <div *ngIf="showSupplierPremiums" class="hover-tip">
              <div *ngFor="let pp of job?.supplierPremiums">
                {{ pp.premium | currency : 'GBP' : 'symbol' : '1.2-2' }} -
                {{ pp.pricePremiumCategory?.categoryName }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pricing-box-inner">
        <div class="flex-grow-1">
          <button
            *ngIf="
              ![
                SupplierInboxType.ExistingLive,
                SupplierInboxType.ExistingWaiting,
                SupplierInboxType.ExistingCancelled,
                SupplierInboxType.ExistingClosed,
                SupplierInboxType.ExistingUnallocated
              ].includes(inboxType)
            "
            pButton
            class="button-style ui-primary-button button-block"
            label="Grab Job"
            (click)="grabJobClick()"
            [style]="{ 'min-width': '200px' }"
          ></button>

          <button
            pButton
            *ngIf="showEditScheduleButton"
            [label]="getEditScheduleButtonLabel()"
            class="mt-2 button-style ui-secondary-button button-block"
            (click)="editSchedule()"
          ></button>

          <button
            pButton
            *ngIf="supplierJobStoreService.handBackEnabled(inboxType)"
            [disabled]="handBackDisabledReason() != null"
            [pTooltip]="handBackDisabledReason()"
            label="Hand Back Job"
            class="mt-2 call-to-action-btn ui-button-danger button-block"
            (click)="onHandBackClick()"
          ></button>
          <!--
                  [disabled]="handBackDisabledReason() != null"
                  -->

          <div
            class="flex grid-gap-10 flex-wrap-reverse flex-wrap"
            style="margin-top: 10px"
            *ngIf="job.supplierId == null"
          >
            <div class="flex-grow-1">
              <div *ngIf="!job.supplierRejected">
                <button
                  pButton
                  class="button-style ui-secondary-button button-block"
                  label="Hide"
                  (click)="hideJob()"
                ></button>
              </div>

              <div *ngIf="job.supplierRejected">
                <button
                  pButton
                  class="button-style ui-secondary-button button-block"
                  label="Hidden"
                  [disabled]="hidingJob"
                  (click)="unHideJob()"
                ></button>
              </div>
            </div>
            <div class="flex-grow-1">
              <div *ngIf="!job.supplierWatching">
                <button
                  pButton
                  class="button-style ui-secondary-button button-block"
                  label="Watch"
                  (click)="watchJob($event)"
                ></button>
              </div>

              <div *ngIf="job.supplierWatching">
                <button
                  pButton
                  class="button-style watching-button button-block"
                  label="Watching"
                  (click)="unWatchJob()"
                ></button>
              </div>
            </div>
            <div class="flex-grow-1" *ngIf="!job.isFromRouteRecommendation">
              <button
                (click)="viewJobDetail($event)"
                pButton
                class="ui-button-secondary btn-block"
                label="Job Details"
              ></button>
            </div>
            <div class="flex-grow-1" *ngIf="job.isFromRouteRecommendation">
              <button
                (click)="viewRouteDetail($event)"
                pButton
                class="ui-button-secondary btn-block"
                label="Route Details"
              ></button>
            </div>
          </div>
          <!--unallocated-->
          <div *ngIf="inboxType == SupplierInboxType.ExistingUnallocated">
            <button
              label="Allocate Truck"
              [disabled]="!selectedJob"
              class="button-style ui-secondary-button button-block mt-2"
              (click)="allocateTruckClick()"
              pButton
            ></button>

            <button
              label="Allocate Driver"
              [disabled]="!selectedJob"
              class="button-style ui-secondary-button button-block mt-2"
              (click)="allocateDriverClick()"
              pButton
            ></button>

            <button
              [label]="job && job.depotId > 0 ? 'Change Depot' : 'Allocate Depot'"
              [disabled]="!selectedJob"
              class="button-style ui-secondary-button button-block mt-2"
              (click)="allocateDepotClick()"
              pButton
            ></button>
          </div>

          <button
            *ngIf="
              [
                SupplierInboxType.ExistingUnallocated,
                SupplierInboxType.ExistingLive,
                SupplierInboxType.ExistingWaiting,
                SupplierInboxType.ExistingClosed,
                SupplierInboxType.ExistingCancelled
              ].includes(inboxType) && !job.isFromRouteRecommendation
            "
            pButton
            class="mt-2 button-style ui-primary-button button-block"
            label="Job Details"
            (click)="viewJobDetail($event)"
            [style]="{ 'min-width': '200px' }"
          ></button>
          <button
            *ngIf="
              [
                SupplierInboxType.ExistingUnallocated,
                SupplierInboxType.ExistingLive,
                SupplierInboxType.ExistingWaiting,
                SupplierInboxType.ExistingClosed,
                SupplierInboxType.ExistingCancelled
              ].includes(inboxType) && job.isFromRouteRecommendation
            "
            pButton
            class="mt-2 button-style ui-primary-button button-block"
            label="Route Details"
            (click)="viewRouteDetail($event)"
            [style]="{ 'min-width': '200px' }"
          ></button>
        </div>
      </div>
    </div>
  </div>
</div>

<p-confirmDialog [key]="job?.id.toString()" header="Confirmation"></p-confirmDialog>

<route-itinerary-popup
  *ngIf="showRouteItineraryPopup"
  [(showDialog)]="showRouteItineraryPopup"
  [selectedRoute]="selectedRoute"
  (closeDialog)="showRouteItineraryPopup = false"
  (routeDetailClick)="viewRouteDetail($event)"
></route-itinerary-popup>
